import { BeginCheckoutEventData } from '@/shared/thirdParty/gtm/types';
import { PaymentInterval, Plan, Price } from '@/shared/types/Billing';

import { getFormattedPlanPrice } from './getFormattedPlanPrice';
import { getPlanGtmName } from './getPlanGtmName';

type GetPlanBeginCheckoutEventData = {
  paymentPeriod: PaymentInterval;
  plan: Plan;
  priceId: Price['id'];
};

export const getPlanBeginCheckoutEventData = ({
  paymentPeriod,
  plan,
  priceId,
}: GetPlanBeginCheckoutEventData): BeginCheckoutEventData => {
  const selectedPriceData = plan.prices.find((price) => price.id === priceId) as Price;
  const selectedPlanPrice = getFormattedPlanPrice({
    paymentInterval: paymentPeriod,
    price: selectedPriceData.unit_amount,
  });

  return {
    ecommerce: {
      currency: selectedPriceData.currency.toUpperCase(),
      items: [
        {
          item_id: plan.id,
          item_name: getPlanGtmName(plan.name, paymentPeriod),
          price: selectedPlanPrice,
          quantity: 1,
        },
      ],
      value: selectedPlanPrice,
    },
  };
};
